<div class="card-content">
    <ng-content></ng-content>
</div>